import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../services/axios';
import toast from 'react-hot-toast';
import { LifebuoyIcon } from '@heroicons/react/24/outline';
import PageHeader from '../../components/common/PageHeader';
import EmptyState from '../../components/common/EmptyState';
import StatusBadge from '../../components/common/StatusBadge';

export default function AdminSupport() {
    const [items, setItems] = useState([]);
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            setLoading(true);
            const res = await axios.get('/support', {
                params: status ? { status } : {}
            });
            setItems(res.data.data || []);
        } catch (err) {
            toast.error(err.response?.data?.message || 'Unable to load support queue');
            setItems([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, [status]);

    return (
        <div className="w-full space-y-6">
            <PageHeader
                title="Support escalations"
                description="Staff view of support requests (program managers and mentors). Students submit via Help & Support."
                actions={
                    <select
                        className="input-field w-auto !mt-0"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        <option value="">All statuses</option>
                        <option value="open">Open</option>
                        <option value="triaged">Triaged</option>
                        <option value="in_progress">In progress</option>
                        <option value="resolved">Resolved</option>
                        <option value="closed">Closed</option>
                    </select>
                }
            />

            <p className="text-sm text-ink-600">
                Students submit via <Link className="font-semibold text-brand-700 hover:text-brand-800" to="/help">Help & Support</Link>.
            </p>

            {loading ? (
                <div className="space-y-3" role="status">
                    <div className="skeleton h-24" />
                    <div className="skeleton h-24" />
                    <span className="sr-only">Loading…</span>
                </div>
            ) : items.length === 0 ? (
                <EmptyState
                    icon={LifebuoyIcon}
                    title="No support requests"
                    description="No support requests in this view."
                />
            ) : (
                <ul className="space-y-2">
                    {items.map((r) => (
                        <li
                            key={r.id}
                            className="card animate-fade-up text-sm"
                        >
                            <div className="flex items-start justify-between gap-3">
                                <p className="font-semibold text-ink-950">{r.subject}</p>
                                <StatusBadge status={r.status} label={r.status} />
                            </div>
                            <p className="text-ink-600 mt-1 line-clamp-3">{r.description}</p>
                            <p className="text-xs text-ink-500 mt-2">
                                {r.category} · routed to {r.routed_to}
                                {r.created_at
                                    ? ` · ${new Date(r.created_at).toLocaleString()}`
                                    : ''}
                            </p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
